import { AudioDevice } from './AudioDevice';
import { AudioDataSource } from './AudioDataSource';
import { AudioData } from './AudioData';
import { ElementAudioData } from './ElementAudioData';
import { IMediaContainer } from './IMediaContainer';
import { AudioSource } from './AudioSource';
import { ElementAudioSource } from './ElementAudioSource';

export class AudioDeviceElement extends AudioDevice {
  async decodeBuffer(sources: AudioDataSource[]): Promise<AudioData | null> {
    return ElementAudioData.Load(sources);
  }

  async openStreamInContainer(
    sources: AudioDataSource[],
    container: IMediaContainer
  ): Promise<AudioData | null> {
    return ElementAudioData.LoadInContainer(sources, container);
  }

  async openStream(sources: AudioDataSource[]): Promise<AudioData | null> {
    return ElementAudioData.Load(sources);
  }

  createSourceImpl(data: AudioData): AudioSource {
    if (data instanceof ElementAudioData) {
      return new ElementAudioSource(data);
    }
    throw new Error(
      'AudioDeviceElement: tried to create ElementAudioSource with wrong AudioData type'
    );
  }

  destroySourceImpl(source: AudioSource): void {
    source.stop();
  }
}
